module.exports = __webpack_public_path__ + "static/img/fieldItemBg.20c07fe0.png";